import { render } from "./RegchargeDetails.vue?vue&type=template&id=cb4010ea&scoped=true"
import script from "./RegchargeDetails.vue?vue&type=script&lang=js"
export * from "./RegchargeDetails.vue?vue&type=script&lang=js"

import "./RegchargeDetails.vue?vue&type=style&index=0&id=cb4010ea&scoped=true&lang=css"

import exportComponent from "C:\\git\\fund\\vfund\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb4010ea"]])

export default __exports__